import { sb } from '../../../supabase.ts';
import { escapeHtml } from '../../../main.ts';

export async function renderOtherSchoolTcPublicPage(app: HTMLElement): Promise<void> {
  const tableName = 'termination_table_others';
  const urlParams = new URLSearchParams(window.location.search);
  const iidParam = urlParams.get('iid') || '';
  const slParam = urlParams.get('sl') || '';

  app.innerHTML = `
    <style>
      .verify-page {
        min-height: 100vh;
        padding: 28px 16px 48px;
        box-sizing: border-box;
        background: #ffffff;
        color: #0f172a;
        font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
        position: relative;
        overflow: hidden;
      }
      .verify-page::before {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(circle at top left, rgba(14, 165, 233, 0.08), transparent 28%), radial-gradient(circle at top right, rgba(236, 72, 153, 0.06), transparent 24%);
        opacity: 1;
        pointer-events: none;
      }
      .verify-shell {
        max-width: 1040px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
      }
      .verify-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 18px;
      }
      .verify-mini {
        font-size: 12px;
        font-weight: 900;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #0f766e;
      }
      .verify-title {
        margin: 6px 0 0;
        font-size: clamp(24px, 3vw, 36px);
        line-height: 1.1;
        letter-spacing: -0.03em;
        font-weight: 900;
        color: #0f172a;
        text-shadow: none;
      }
      .verify-subtitle {
        margin: 8px 0 0;
        max-width: 720px;
        line-height: 1.55;
        color: #475569;
      }
      .verify-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        background: linear-gradient(135deg, rgba(14, 165, 233, 0.95), rgba(236, 72, 153, 0.92));
        color: #ffffff;
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 999px;
        font-size: 13px;
        font-weight: 800;
        white-space: nowrap;
        box-shadow: 0 12px 28px rgba(14, 165, 233, 0.24);
      }
      .verify-card {
        background: rgba(255, 255, 255, 0.94);
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 24px;
        box-shadow: 0 24px 60px rgba(0, 0, 0, 0.26);
        overflow: hidden;
        backdrop-filter: blur(12px);
      }
      .verify-card-header {
        padding: 22px 24px 18px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        border-bottom: 1px solid rgba(15, 23, 42, 0.06);
        background:
          linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.98)),
          linear-gradient(90deg, rgba(14, 165, 233, 0.18), rgba(236, 72, 153, 0.14), rgba(245, 158, 11, 0.12));
      }
      .verify-card-header h2 {
        margin: 0;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 900;
        color: #0f172a;
      }
      .verify-status {
        margin-top: 6px;
        font-size: 13px;
        color: #475569;
      }
      .verify-summary {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        gap: 12px;
        padding: 20px 24px 0;
      }
      .verify-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 12px;
        padding: 18px 24px 24px;
      }
      .verify-field {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(248, 250, 252, 0.98));
        border: 1px solid rgba(15, 23, 42, 0.06);
        border-radius: 16px;
        padding: 14px 16px;
        position: relative;
        overflow: hidden;
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
      }
      .verify-summary .verify-field {
        background: #ffffff;
      }
      .verify-summary .verify-field:nth-child(4n+1) {
        border-top: 4px solid #0ea5e9;
      }
      .verify-summary .verify-field:nth-child(4n+2) {
        border-top: 4px solid #f97316;
      }
      .verify-summary .verify-field:nth-child(4n+3) {
        border-top: 4px solid #ec4899;
      }
      .verify-summary .verify-field:nth-child(4n+4) {
        border-top: 4px solid #10b981;
      }
      .verify-grid .verify-field:nth-child(5n+1) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(239, 246, 255, 0.96));
      }
      .verify-grid .verify-field:nth-child(5n+2) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(255, 247, 237, 0.96));
      }
      .verify-grid .verify-field:nth-child(5n+3) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(252, 231, 243, 0.96));
      }
      .verify-grid .verify-field:nth-child(5n+4) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(236, 253, 245, 0.96));
      }
      .verify-grid .verify-field:nth-child(5n+5) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(254, 249, 195, 0.92));
      }
      .verify-key {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #475569;
        font-weight: 800;
      }
      .verify-value {
        margin-top: 6px;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 800;
        color: #0f172a;
        word-break: break-word;
      }
      .verify-footer {
        padding: 0 24px 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
        color: #475569;
        font-size: 13px;
      }
      .verify-alert {
        background: linear-gradient(135deg, rgba(248, 113, 113, 0.14), rgba(253, 224, 71, 0.18));
        border: 1px solid rgba(244, 63, 94, 0.18);
        color: #9f1239;
        border-radius: 14px;
        padding: 14px 16px;
        font-weight: 700;
      }
      @media (max-width: 700px) {
        .verify-top,
        .verify-card-header {
          flex-direction: column;
        }
        .verify-card-header {
          align-items: stretch;
        }
        .verify-badge {
          width: fit-content;
        }
      }
    </style>

    <div class="verify-page">
      <div class="verify-shell">
        <div class="verify-top">
          <div>
            <div class="verify-mini">Other School TC</div>
            <h1 class="verify-title">Public Verification</h1>
            <p class="verify-subtitle">This page opens from the QR code printed on the Transfer Certificate and shows the core record details for quick validation.</p>
          </div>
          <div class="verify-badge" id="verifyStatus">Loading...</div>
        </div>

        <div class="verify-card">
          <div class="verify-card-header">
            <div>
              <h2>Transfer Certificate Details</h2>
              <div class="verify-status" id="verifyStatusLine">Fetching record...</div>
            </div>
            <div class="verify-badge" style="background: rgba(15, 23, 42, 0.06); color: #0f172a; border-color: rgba(15, 23, 42, 0.08);">QR Verify</div>
          </div>

          <div class="verify-summary" id="verifySummary"></div>
          <div class="verify-grid" id="verifyDetails"></div>
          <div class="verify-footer">
            <div id="verifyNote">Open this link directly from the QR scan to validate the record.</div>
          </div>
        </div>
      </div>
    </div>
  `;

  const verifyStatus = document.getElementById('verifyStatus')!;
  const verifyStatusLine = document.getElementById('verifyStatusLine')!;
  const verifySummary = document.getElementById('verifySummary')!;
  const verifyDetails = document.getElementById('verifyDetails')!;
  const verifyNote = document.getElementById('verifyNote')!;

  function formatValue(value: any): string {
    const text = String(value ?? '').trim();
    return text ? escapeHtml(text) : '---';
  }

  function renderField(label: string, value: any): string {
    return `
      <div class="verify-field">
        <div class="verify-key">${escapeHtml(label)}</div>
        <div class="verify-value">${formatValue(value)}</div>
      </div>
    `;
  }

  function mapStudentRecord(stu: any): any {
    const session = stu.session || 2025;
    return {
      tc_sl: stu.tc_no || null,
      iid: stu.iid,
      student_name_en: stu.student_name_en || stu.name_en || '',
      father_name_en: stu.father_name_en || '',
      mother_name_en: stu.mother_name_en || '',
      tc_class: stu[`class_${session}`] || stu.class || '',
      tc_section: stu[`section_${session}`] || stu.section || '',
      tc_roll: stu[`roll_${session}`] || stu.roll || '',
      board_registration: stu.board_registration || '',
      student_dateofbirth: stu.student_dateofbirth || '',
      paid_month: stu.paid_month || 'December 2025',
      tc_session: String(session),
      issued_by: stu.issued_by || '',
      father_mobile: stu.father_mobile || stu.guardian_mobile || '',
      tc_date: stu.tc_date || '',
    };
  }

  async function loadVerification() {
    if (!iidParam && !slParam) {
      verifyStatus.textContent = 'Missing QR parameter';
      verifyStatus.style.background = 'rgba(239, 68, 68, 0.08)';
      verifyStatus.style.color = '#b91c1c';
      verifyStatusLine.innerHTML = '<span class="verify-alert">No IID or SL was provided in the URL.</span>';
      verifySummary.innerHTML = '';
      verifyDetails.innerHTML = '';
      verifyNote.textContent = 'The QR link should contain an IID parameter.';
      return;
    }

    try {
      let rec: any = null;

      let query = sb.from(tableName).select('*').limit(1);
      if (iidParam) query = query.eq('iid', iidParam);
      if (slParam) query = query.eq('tc_sl', slParam);

      const { data, error } = await query;
      if (error) throw error;

      if (data && data.length) {
        rec = data[0];
      } else if (iidParam) {
        const { data: stuData, error: stuErr } = await sb
          .from('student_database_others')
          .select('*')
          .eq('iid', iidParam)
          .limit(1);

        if (stuErr) throw stuErr;

        if (stuData && stuData.length) {
          rec = mapStudentRecord(stuData[0]);
        }
      }

      if (!rec) {
        verifyStatus.textContent = 'Record not found';
        verifyStatus.style.background = 'rgba(239, 68, 68, 0.08)';
        verifyStatus.style.color = '#b91c1c';
        verifyStatusLine.innerHTML = '<span class="verify-alert">No Transfer Certificate record matched this QR link.</span>';
        verifySummary.innerHTML = '';
        verifyDetails.innerHTML = '';
        verifyNote.textContent = 'Check the QR link or confirm the record exists in the TC table.';
        return;
      }

      verifyStatus.textContent = 'Verified';
      verifyStatus.style.background = 'rgba(16, 185, 129, 0.12)';
      verifyStatus.style.color = '#047857';
      verifyStatusLine.textContent = `Loaded record for IID ${rec.iid || '---'}`;

      const summaryFields = [
        ['SL', rec.tc_sl],
        ['IID', rec.iid],
        ['Name', rec.student_name_en],
        ['Session', rec.tc_session],
      ];

      const detailFields = [
        ['Father', rec.father_name_en],
        ['Mother', rec.mother_name_en],
        ['Class', rec.tc_class],
        ['Section', rec.tc_section],
        ['Roll', rec.tc_roll],
        ['Reg No', rec.board_registration || '---'],
        ['DOB', rec.student_dateofbirth],
        ['Paid Month', rec.paid_month],
        ['Mobile', rec.father_mobile],
        ['TC Date', rec.tc_date],
        ['Issued By', 'Headmaster, Feni Model High School.'],
      ];

      verifySummary.innerHTML = summaryFields.map(([label, value]) => renderField(label, value)).join('');
      verifyDetails.innerHTML = detailFields.map(([label, value]) => renderField(label, value)).join('');
      verifyNote.textContent = 'These details are generated from the record linked to the QR code.';
    } catch (error: any) {
      console.error(error);
      verifyStatus.textContent = 'Load failed';
      verifyStatus.style.background = 'rgba(239, 68, 68, 0.08)';
      verifyStatus.style.color = '#b91c1c';
      verifyStatusLine.innerHTML = '<span class="verify-alert">Failed to load verification data.</span>';
      verifySummary.innerHTML = '';
      verifyDetails.innerHTML = '';
      verifyNote.textContent = 'Try scanning the QR again or open the link from a verified certificate.';
    }
  }

  await loadVerification();
}